<template>
  <section class="login-container">
    <section class="login-left">
      <div class="logo-lang">
         <el-image class="sys-logo" :src="Logo"></el-image>
         <change-language @reload="changeLanguage"/>
       </div>
      <div class="login-form-container">
        <div class="form-tabs">
          <div class="login-form-title" :class="{ active: loginType == 1 }" @click="handleLoginTypeSwitch(1)">{{$t('login.txt001')}}</div>
          <div class="login-form-title" :class="{ active: loginType == 2 }" @click="handleLoginTypeSwitch(2)">{{$t('login.txt027')}}</div>
        </div>
        <div class="login-form-content">
          <el-form class="login-form-entity" ref="loginForm" :model="loginForm" :rules="loginRules" :status-icon="false" :show-message="false">
            <!--密码登录-->
            <template v-if="loginType == 1">
              <el-form-item prop="username" class="item-user-password">
                <el-input size="medium" v-model="loginForm.username" debounce="0" :placeholder="$t('login.txt011')" /><!-- 请输入账号 -->
              </el-form-item>
              <el-form-item prop="password" class="item-user-password">
                <el-input size="medium" @keyup.enter.native="handleLogin" :type="passwordType" v-model="loginForm.password" :placeholder="$t('login.txt012')" ><!-- 请输入密码 -->
                  <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword"></i>
                </el-input>
              </el-form-item>
              <el-form-item prop="validCode">
                <div class="code-container">
                  <el-input class="code" size="medium" @keyup.enter.native="handleLogin" v-model="loginForm.validCode" auto-complete="off" :placeholder="$t('login.txt013')" /><!-- 请输入验证码 -->
                  <el-image class="code-img" :src="imageUrl" fit="cover" @click="refreshCode"></el-image>
                </div>
              </el-form-item>
            </template>
            <!--验证码登录-->
            <template v-else>
              <el-form-item prop="phoneNum" class="item-user-password">
                <el-input size="medium" @keyup.enter.native="handleLogin" v-model="loginForm.phoneNum" debounce="0" :placeholder="$t('login.txt011-2')" /><!-- 请输入手机号 -->
              </el-form-item>
              <el-form-item prop="verifyCode" class="item-user-password">
                <el-input class="code" size="medium" @keyup.enter.native="handleLogin" v-model="loginForm.verifyCode" auto-complete="off" :placeholder="$t('login.txt013-2')" maxlength="6" /><!-- 请输入短信验证码 -->
                <el-button class="code-btn" type="primary" round :disabled="codeFlag" @click="sendSmsVerifyCode">{{ getCode }}</el-button>
              </el-form-item>
              <el-form-item class="item-user-password">
                <div style="height: 0.5rem"></div>
              </el-form-item>
            </template>
            <el-form-item>
              <div style="margin: 0 10px;">
                <el-checkbox class="checkbox" v-model="checked" size="medium"></el-checkbox>
                <span style="color: #999;">{{$t('login.txt004')}}</span>
                <a style="color: #1c1c1c; margin-left: 3px;" href="https://fssccloud.ciicpt.com.cn/privacyPolicy.action" target="_blank">
                  <i class="el-icon-d-arrow-left arrow arrow-left"></i>{{$t('login.txt005')}}<i class="el-icon-d-arrow-right arrow arrow-right"></i><!-- 隐私政策 -->
                </a>
                <el-link v-show="loginType == 1" type="info" :underline="false" @click="handleResetPwd" style="float: right;">{{$t('login.txt002')}}</el-link><!-- 忘记密码 -->
              </div>
            </el-form-item>
            <el-form-item class="login-button-item" style="margin-top: 0.6rem">
              <el-button type="danger" :loading="loginLoading" size="medium" @click.native.prevent="handleLogin" class="login-submit">{{$t('login.txt003')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </section>
    <section class="login-right">
      <div class="sys-info">
        <div class="sys-name-box">
          <el-image class="sys-name" :src="sysNameUrl"></el-image>
        </div>
        <div class="sys-subtitle-box">
          <el-image class="sys-subtitle" :src="sysSubtitleUrl"></el-image>
        </div>

        <div class="about-us">
          <div class="about-us-button" @click="aboutus">{{$t('login.txt006')}}</div><!-- 关于我们 -->
        </div>
      </div>
      <div class="copyright">
        <span>{{$t('login.txt007')}}</span><!-- 中智薪税技术服务有限公司 -->
        <span>京公网安备11010502042147号</span>
        <span>京ICP备07500522号</span>
      </div>
    </section>
    <section class="fixed-right">
      <!--<div class="sale-container service-shadow">-->
        <!--<el-popover placement="left" trigger="hover">-->
          <!--<el-image class="salesperson-code" :src="IconSalesperson" slot="reference"></el-image>-->
          <!--<div class="fixed-right-code-content">-->
            <!--<div class="fixed-right-code">-->
              <!--<el-image class="salesperson-code-img" :src="CodeSalesperson"></el-image>-->
            <!--</div>-->
            <!--<div class="code-desc">欢迎扫码加客服微信</div>-->
          <!--</div>-->
        <!--</el-popover>-->
      <!--</div>-->
      <div class="service-container service-shadow">
        <el-popover placement="left" trigger="hover">
          <div class="service-item service" slot="reference">
            <el-image class="service-item-icon" :src="IconService"></el-image>
          </div>
          <div class="fixed-right-code-content">
            <div class="fixed-right-title">
              <el-image class="fixed-right-title-icon" :src="IconTel"></el-image>
              <div class="fixed-right-title-text">
                <p>{{$t('login.txt008')}}</p><!-- 客服热线 -->
                <p>4000268558-1-2</p>
              </div>
            </div>
            <div class="fixed-right-code">
              <el-image class="salesperson-code-img" :src="CodeCallCenter"></el-image>
            </div>
            <div class="code-desc">{{$t('login.txt009')}}</div><!-- 扫一扫，联系我们 -->
          </div>
        </el-popover>
        <el-popover placement="left" trigger="hover">
          <div class="service-item official" slot="reference">
            <el-image class="service-item-icon" :src="IconOfficial"></el-image>
          </div>
          <div class="fixed-right-code-content">
            <div class="fixed-right-code">
              <el-image class="salesperson-code-img" :src="CodeOfficial"></el-image>
            </div>
            <div class="code-desc">{{$t('login.txt010')}}</div><!-- 扫码关注公众号 -->
          </div>
        </el-popover>
      </div>
    </section>

    <update-pwd :visible.sync="forgetPwd" />
  </section>
</template>

<script>
  import Logo from '@/assets/img/login/logo.png'
  import SysName from '@/assets/img/login/sys-name.png'
  import SysSubtitle from '@/assets/img/login/sys-subtitle.png'
  import SysNameEn from '@/assets/img/login/sys-name-en.png'
  import SysSubtitleEn from '@/assets/img/login/sys-subtitle-en.png'
  import IconSalesperson from '@/assets/img/login/icon-salesperson.png'
  import IconService from '@/assets/img/login/icon-service.png'
  import IconOfficial from '@/assets/img/login/icon-official.png'
  import IconTel from '@/assets/img/login/icon-tel.png'
  import CodeSalesperson from '@/assets/img/login/code-salesperson.png'
  import CodeOfficial from '@/assets/img/login/code_img.jpg'
  import CodeCallCenter from '@/assets/img/login/code-call-center.png'
  import ChangeLanguage from '@/page/index/top/change-language'
  import UpdatePwd from './components/UpdatePwd'
  import { base64Encode } from '@/util/endecode'
  import { setRem, filterNullValue } from "@/util/commen";
  import { isvalidatemobile } from "@/util/validate"
  import { sendSmsVerifyCode } from '@/api/user/login'

  export default {
    name: "Login",
    components: {
      ChangeLanguage,
      UpdatePwd
    },
    data(){
      return {
        Logo,
        SysName,
        SysSubtitle,
        IconSalesperson,
        IconService,
        IconOfficial,
        IconTel,
        CodeSalesperson,
        CodeOfficial,
        CodeCallCenter,
        checked: false,
        loginType: 1,
        loginForm: {
          username: "",
          validCode: '',
          password: "",
          phoneNum: "",
          verifyCode: "",
          targetSys: "hosepc"
        },
        imageUrl:'/api/image-code/code',
        loginRules: {
          username: [
            { required: true, message: this.$t('login.txt016'), trigger: "blur" } //请输入账号
          ],
          password: [
            { required: true, message: this.$t('login.txt017'), trigger: "blur" } //请输入密码
          ],
          validCode: [
            { required: true, message: this.$t('login.txt018'), trigger: 'blur' }, //请输入验证码
            { min: 4, max: 4, message: this.$t('login.txt019'), trigger: 'blur' } //验证码长度为4位
          ],
          phoneNum: [
            { required: true, message: this.$t('login.txt021'), trigger: 'blur' },
            { validator: this.validatePhone, trigger: 'blur' }
          ],
          verifyCode: [
            { required: true, message: this.$t('login.txt020'), trigger: 'blur' },
            { min: 6, max: 6, message: this.$t('login.txt026'), trigger: 'blur' }
          ]
        },
        passwordType: "password",
        loginLoading: false,
        forgetPwd: false,
        sysNameUrl : "",
        sysSubtitleUrl: "",
        codeFlag: false,
        getCode: this.$t('login.txt025'), //获取验证码
        timer: null,
        countdown: 60,
      }
    },
    created() {
      //回车事件
      document.onkeydown = (e) => {
        var ev = document.all ? window.event : e;
        if(ev.keyCode == 13) {
          if(!this.loginLoading){
            this.handleLogin();
          }
        }
      }

      this.refreshCode()
      this.changeLanguage()
    },
    beforeDestroy() {
      this.clearTimer();
    },
    methods: {
      // 切换语言
      handleLoginTypeSwitch(val) {
        this.loginType = val
        this.loginForm = {}
      },
      aboutus() {
        window.open('http://www.ciicpt.com.cn')
      },
      changeLanguage(){
        var lang =  localStorage.getItem('Accept-Language') || 'zh-CN';
        if(lang == 'zh-CN'){
          this.sysNameUrl = SysName;
          this.sysSubtitleUrl = SysSubtitle
        }else{
          this.sysNameUrl = SysNameEn;
          this.sysSubtitleUrl = SysSubtitleEn
        }
        this.getCode = this.$t('login.txt025');
      },
      // 刷新验证码
      refreshCode() {
        let num = Math.floor(Math.random() * (10000 - 10 + 1)) + 10;
        this.imageUrl = "/api/image-code/code?num=" + num;
        this.$forceUpdate();
      },
      // 密码显示隐藏切换
      showPassword() {
        this.passwordType == '' ? (this.passwordType = 'password') : (this.passwordType = '');
      },
      // 忘记密码页面
      handleResetPwd() {
        this.forgetPwd = true
      },
      // 获取验证码
      sendSmsVerifyCode() {
        if (this.codeFlag) return;
        if (!this.loginForm.phoneNum) {
          this.$message.error(this.$t('login.txt021'));
          return;
        }
        const phoneValid = isvalidatemobile(this.loginForm.phoneNum);
        if (phoneValid[0]) {
          this.$message.error(this.$t('login.txt022'));
          return;
        }
        this.codeFlag = true;

        // this.$message.error("您所在的机构尚未开通短信验证码登录！");
        // this.countDownFinished();

        sendSmsVerifyCode({ phoneNum: this.loginForm.phoneNum })
          .then(() => {
            this.$message.success(this.$t('login.txt023'));
            this.startCountdown(60);
          })
          .catch(() => {
            this.$message.error(this.$t('login.txt024'));
            //this.countDownFinished();
            this.startCountdown(10);
          })
      },
      // 倒计时结束
      countDownFinished() {
        this.clearTimer();
        this.codeFlag = false;
        this.countdown = 60;
        this.getCode = this.$t('login.txt025');
      },
      // 倒计时
      startCountdown(waitTime) {
        if(!waitTime){
          this.countdown = 60;
        }else{
          this.countdown = waitTime;
        }

        this.getCode = `${this.countdown}s`;
        this.timer = setInterval(() => {
          this.countdown -= 1;
          if (this.countdown <= 0) {
            this.countDownFinished();
          } else {
            this.getCode = `${this.countdown}s`;
          }
        }, 1000);
      },
      // 手机号校验
      validatePhone(rule, value, callback) {
        if (!value) {
          callback(new Error(this.$t('login.txt021')));
          return;
        }
        const phoneValid = isvalidatemobile(value);
        if (phoneValid[0]) {
          callback(new Error(this.$t('login.txt022')));
        } else {
          callback();
        }
      },
      // 清除定时器
      clearTimer() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },
      // 立即登录
      handleLogin() {
        this.$refs.loginForm.validate((valid, message) => {
          if (valid) {
            if (!this.checked) {
              this.$message.error(this.$t('login.txt014'))// 请同意隐私政策
              return
            }

            // if(this.loginType == 2){
            //   this.$message.error("您所在的机构尚未开通短信验证码登录！")
            //   return
            // }

            this.loginLoading = true;
            this.loginForm.loginType = this.loginType + '';
            const params = filterNullValue(this.loginForm)
            this.$store.dispatch("LoginByUsername", params).then((res) => {
                if (res.data.data.success == "false") {
                  this.loginLoading = false;
                  this.show = true
                  this.refreshCode()
                  this.$message.error(res.data.data.msg);
                } else {
                  if(res.data.data.user.sysInterfaceFlag == "80600002"){
                    if(res.data.data.fcsUrl){
                      window.location.replace(res.data.data.fcsUrl)
                    }else{
                      this.loginLoading = false;
                      this.show = true
                      this.refreshCode()
                      this.$message.error("登录异常，请联系管理员！");
                    }
                  }else{
                    this.$router.push({ path: "/index" });
                    this.$message.success(this.$t('login.txt015'));//登陆成功
                  }
                }
              }
            ).catch((error) => {
              this.loginLoading = false;
              this.show = true
              if (error.data && error.data.data.msg) {
                this.refreshCode()
                this.$message.error(error.data.data.msg);
              }
            });
          } else {
            const validArr = Object.keys(message)
            const msg = message[validArr[0]][0].message
            this.$message.error(msg);
          }
        });
      }
    }
  }
</script>
